import { type FeedbackList, FeedbackListSchema } from '@sbc/domain-models/agents';
import { useQuery } from '@tanstack/react-query';

import { apiGet } from './client';

const FEEDBACK_KEY = ['admin', 'feedback'];

export function useFeedback() {
  return useQuery<FeedbackList>({
    queryKey: FEEDBACK_KEY,
    queryFn: () => apiGet('/api/admin/feedback', FeedbackListSchema),
  });
}
